import type { HTMLProps, ReactNode } from 'react'

import cx from 'classnames'
import { useContext } from 'react'

import { Divider } from '../Divider'

import styles from './card.module.css'
import { CardContext } from './context'
import { ExpandableButton } from './expandable-button'

type Props = {
  children: ReactNode
  expandable?: boolean
  onChangeOpen?: (value: boolean) => void
  open?: boolean
  hideBorders?: boolean
} & HTMLProps<HTMLDivElement>

export function Header ({ children, expandable, onChangeOpen, open, hideBorders, ...rest }: Props): JSX.Element {
  const cardContext = useContext(CardContext)

  const currentValue = typeof open === 'boolean'
    ? open
    : typeof cardContext?.open === 'boolean'
      ? cardContext.open
      : true

  return (
    <>
      <div
        {...rest}
        className={cx(styles.cardHeader, rest.className)}
      >
        {(expandable ?? cardContext.showExpandableHandler) && (
          <ExpandableButton
            open={open}
            onChangeOpen={onChangeOpen}
          />
        )}

        {typeof children === 'string'
          ? <h2>{children}</h2>
          : children
        }
      </div>
      {currentValue && !hideBorders && (
        <Divider />
      )}
    </>
  )
}
